import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, renderSlot as _renderSlot, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, mergeProps as _mergeProps, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@img/icon-close2.png'


const _withScopeId = n => (_pushScopeId("data-v-18c72bea"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "title"
}
const _hoisted_2 = {
  key: 1,
  class: "content"
}
const _hoisted_3 = {
  key: 2,
  class: "options"
}

import { Modal } from "ant-design-vue";
import { toRefs } from "vue";
import SvgIcon from "@component/SvgIcon/index.vue";
interface Props {
  isShow: boolean;
  title?: string;
  content?: string;
  okText?: string;
  cancelText?: string;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    isShow: { type: Boolean },
    title: null,
    content: null,
    okText: null,
    cancelText: null
  },
  emits: ["onCancel", "onConfirm", "onClose"],
  setup(__props: any, { emit }) {

const props = __props as {
  isShow: boolean;
  title?: string;
  content?: string;
  okText?: string;
  cancelText?: string;
};



const { isShow } = toRefs(props);

const handleCancel = () => {
  console.log("handleCancel");
  emit("onCancel");
};

const handleClose = () => {
  console.log("handleClose");
  emit("onClose");
};

const handleConfrim = () => {
  console.log("handleConfrim");
  emit("onConfirm");
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Modal), _mergeProps({ visible: _unref(isShow) }, _ctx.$attrs, {
    width: _ctx.$attrs.width || '480px',
    footer: null,
    centered: true,
    onCancel: handleClose,
    wrapClassName: "__custom-modal",
    closable: false
  }), {
    default: _withCtx(() => [
      _createElementVNode("img", {
        src: _imports_0,
        alt: "",
        class: "custom-close",
        onClick: handleClose
      }),
      _renderSlot(_ctx.$slots, "default"),
      (__props.title)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("p", null, _toDisplayString(__props.title), 1)
          ]))
        : _createCommentVNode("", true),
      (__props.content)
        ? (_openBlock(), _createElementBlock("p", _hoisted_2, _toDisplayString(__props.content), 1))
        : _createCommentVNode("", true),
      (__props.cancelText || __props.okText)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _withDirectives(_createElementVNode("div", {
              class: "cancel flex-btn",
              onClick: handleCancel
            }, _toDisplayString(__props.cancelText), 513), [
              [_vShow, __props.cancelText]
            ]),
            _withDirectives(_createElementVNode("div", {
              class: "confirm flex-btn",
              onClick: handleConfrim
            }, _toDisplayString(__props.okText), 513), [
              [_vShow, __props.okText]
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 3
  }, 16, ["visible", "width"]))
}
}

})